import React from "react";
import "./Footer.css";
import { Container } from "./Container";
import { BrandMark } from "./BrandMark";

type Item = { id: string; label: string };

export function Footer({ items, onNavigate }: { items: Item[]; onNavigate: (id: string) => void }) {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <div className="footerGrid">
          <div className="footerBrand">
            <div className="footerBrandRow">
              <BrandMark />
              <div>
                <div className="footerTitle">Кристина Глухова</div>
                <div className="footerSubtitle">блоггер • мама • лайфстайл</div>
              </div>
            </div>
            <div className="footerText">
              Тёплый контент про реальную жизнь, материнство и уют. Для сотрудничества — напишите через форму.
            </div>
          </div>

          <div className="footerNav" aria-label="Разделы">
            <div className="footerColTitle">Навигация</div>
            <div className="footerLinks">
              {items.map((it) => (
                <button key={it.id} className="footerLink" onClick={() => onNavigate(it.id)}>
                  {it.label}
                </button>
              ))}
            </div>
          </div>

          <div className="footerMeta">
            <div className="footerColTitle">Контакты</div>
            <div className="footerTextSmall">
              Email:{" "}
              <a className="footerA" href="mailto:hello@kristina-glukhova.example">
                hello@kristina-glukhova.example
              </a>
            </div>
            <div className="footerTextSmall">Город: онлайн / удалённо</div>
            <div className="footerPillRow">
              <span className="footerPill">интеграции</span>
              <span className="footerPill">UGC</span>
              <span className="footerPill">контент-пакеты</span>
            </div>
          </div>
        </div>

        <div className="footerBottom">
          <div className="footerCopy">© {year} Кристина Глухова. Все права защищены.</div>
          <button className="toTop" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Наверх ↑
          </button>
        </div>
      </Container>
    </footer>
  );
}